export class StringUtil {
  escapeSpecials(string: string): string {
    const pattern = "\\\\";
    const regexp = new RegExp("[" + pattern + "]", "g");
    return string.replace(regexp, "");
  }

  trimLeft(string: string): string {
    return string.replace(/^\s+/, "");
  }

  trimRight(string: string): string {
    return string.replace(/\s+$/, "");
  }
}

export class GlobalUtil {
  setLocation(target: string) {
    (window as any).location = target;
  }
}

export class CoreUtil {
  private value = 0;

  nextValue(): number {
    return ++this.value;
  }

  /**
   * Creates a self incrementing function.
   *
   * @example
   * var foo = counter();
   * foo(); // -> 1
   * foo(); // -> 2
   *
   * @param [start=1] initial value
   * @returns the initialized nextValue() function
   */
  counter(start?: number): CoreUtil["nextValue"] {
    return window.o_util.core.bind({ value: (start || 1) - 1 }, this.nextValue);
  }
}

export interface Util {
  string: StringUtil;
  global: GlobalUtil;
  core: CoreUtil;
}

export const util = {
  string: new StringUtil(),
  global: new GlobalUtil(),
  core: new CoreUtil(),
};
